import {matchPath, useLocation} from 'react-router';

import {ECompanyNewsTab} from 'src/containers/CompanyNews/definitions';
import {EMessageMatchersTab} from 'src/containers/MessageMatchers/definitions';
import {EUserCompanyProfileTabs} from 'src/containers/UserCompanyProfile/definitions';

export type TPathPostfix = typeof EDIT_POSTFIX | typeof VIEW_POSTFIX | typeof NEW_POSTFIX;

export const AUTH_PATH_PREFIX = '/auth';
export const USER_AUTH_PATH_PREFIX = '/user-auth';
export const EDIT_POSTFIX = 'edit';
export const NEW_POSTFIX = 'new';
export const VIEW_POSTFIX = 'view';
export const CHANNELS_PREFIX = '/channels';
export const CHANNELS_TECH_PARTNER_POSTFIX = '-tech-partner';
export const MESSAGE_MATCHERS_PREFIX = '/message-matchers';
export const TRIGGERS_PREFIX = '/triggers';
export const SUPPORT_PREFIX = '/support';
export const SUPPORT_CLIENTS_PREFIX = '/support/clients';

const PATHS = {
  HOME: '/',
  UNAVAILABLE: '/unavailable',

  // Public
  PUBLIC_DOCS: '/public/docs',
  PUBLIC_WHATSAPP_REGISTRATION: `/public/register-whatsapp/:code`,
  PUBLIC_WHATSAPP_BUSINESS_APP_REGISTRATION: `/public/register-whatsapp-business-app/:code`,
  PUBLIC_MAX_REGISTRATION: `/public/register-max/:code`,
  PUBLIC_TELEGRAM_REGISTRATION: `/public/register-telegram/:code`,

  // Auth
  SIGN_IN: `${AUTH_PATH_PREFIX}/signin`,
  PASSWORD_SAVED: `${AUTH_PATH_PREFIX}/password-saved`,
  SIGN_IN_TENANT_BY_INVITE: `${AUTH_PATH_PREFIX}/signin/:hash`,
  SIGN_IN_USER_BY_INVITE: `${USER_AUTH_PATH_PREFIX}/signin/:hash`,
  EMAIL_CONFIRM: `${AUTH_PATH_PREFIX}/email-confirm`,
  SIGN_UP: `${AUTH_PATH_PREFIX}/signup`,
  SIGN_UP_FROM_AGENT: `${AUTH_PATH_PREFIX}/signup/:agentId`,

  // Channels
  CHANNELS: `${CHANNELS_PREFIX}/tabs`,
  CHANNELS_TABS: `${CHANNELS_PREFIX}/tabs/:tab`,
  CHANNELS_LIST: `${CHANNELS_PREFIX}/tabs/list`,

  CHANNELS_VERIFICATION: `${CHANNELS_PREFIX}/tabs/verification`,
  CHANNELS_VERIFICATION_NEW: `${CHANNELS_PREFIX}/verification/${NEW_POSTFIX}`,
  CHANNELS_VERIFICATION_EDIT: `${CHANNELS_PREFIX}/verification/:id/${EDIT_POSTFIX}`,
  CHANNELS_VERIFICATION_VIEW: `${CHANNELS_PREFIX}/verification/:id/${VIEW_POSTFIX}`,

  CHANNELS_WHATSAPP_NEW: `${CHANNELS_PREFIX}/whatsapp/${NEW_POSTFIX}`,
  CHANNELS_WHATSAPP_EDIT: `${CHANNELS_PREFIX}/whatsapp/:id/${EDIT_POSTFIX}`,
  CHANNELS_WHATSAPP_VIEW: `${CHANNELS_PREFIX}/whatsapp/:id/${VIEW_POSTFIX}`,
  CHANNELS_WHATSAPP_TECH_PARTNER_NEW: `${CHANNELS_PREFIX}/whatsapp${CHANNELS_TECH_PARTNER_POSTFIX}/${NEW_POSTFIX}`,
  CHANNELS_WHATSAPP_TECH_PARTNER_EDIT: `${CHANNELS_PREFIX}/whatsapp${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${EDIT_POSTFIX}`,
  CHANNELS_WHATSAPP_TECH_PARTNER_VIEW: `${CHANNELS_PREFIX}/whatsapp${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${VIEW_POSTFIX}`,
  CHANNELS_WHATSAPP_BUSINESS_APP_NEW: `${CHANNELS_PREFIX}/whatsapp-business-app/${NEW_POSTFIX}`,
  CHANNELS_WHATSAPP_BUSINESS_APP_EDIT: `${CHANNELS_PREFIX}/whatsapp-business-app/:id/${EDIT_POSTFIX}`,
  CHANNELS_WHATSAPP_BUSINESS_APP_TECH_PARTNER_NEW: `${CHANNELS_PREFIX}/whatsapp-business-app${CHANNELS_TECH_PARTNER_POSTFIX}/${NEW_POSTFIX}`,

  CHANNELS_VIBER_NEW: `${CHANNELS_PREFIX}/viber/${NEW_POSTFIX}`,
  CHANNELS_VIBER_EDIT: `${CHANNELS_PREFIX}/viber/:id/${EDIT_POSTFIX}`,
  CHANNELS_VIBER_VIEW: `${CHANNELS_PREFIX}/viber/:id/${VIEW_POSTFIX}`,
  CHANNELS_SMS_NEW: `${CHANNELS_PREFIX}/sms/${NEW_POSTFIX}`,
  CHANNELS_SMS_EDIT: `${CHANNELS_PREFIX}/sms/:id/${EDIT_POSTFIX}`,
  CHANNELS_SMS_VIEW: `${CHANNELS_PREFIX}/sms/:id/${VIEW_POSTFIX}`,

  CHANNELS_PUSH_NEW: `${CHANNELS_PREFIX}/push/${NEW_POSTFIX}`,
  CHANNELS_PUSH_LIST: `${CHANNELS_PREFIX}/push/:pushId/apps`,
  CHANNELS_PUSH_APP_DATA: `${CHANNELS_PREFIX}/push/:pushId/apps/:appType/:appId/data`,
  CHANNELS_PUSH_APP_NEW: `${CHANNELS_PREFIX}/push/:pushId/apps/:appType/${NEW_POSTFIX}`,
  CHANNELS_PUSH_IOS_NEW_STEP: `${CHANNELS_PREFIX}/push/:pushId/apps/ios/${NEW_POSTFIX}/:step`,
  CHANNELS_PUSH_ANDROID_NEW_STEP: `${CHANNELS_PREFIX}/push/:pushId/apps/android/${NEW_POSTFIX}/:step`,
  CHANNELS_PUSH_IOS_EDIT: `${CHANNELS_PREFIX}/push/:pushId/apps/ios/:appId/${EDIT_POSTFIX}/:step`,
  CHANNELS_PUSH_ANDROID_EDIT: `${CHANNELS_PREFIX}/push/:pushId/apps/android/:appId/${EDIT_POSTFIX}/:step`,

  CHANNELS_VK_NOTIFY_NEW: `${CHANNELS_PREFIX}/vk-notify/${NEW_POSTFIX}`,
  CHANNELS_VK_NOTIFY_EDIT: `${CHANNELS_PREFIX}/vk-notify/:id/${EDIT_POSTFIX}`,
  CHANNELS_VK_NOTIFY_VIEW: `${CHANNELS_PREFIX}/vk-notify/:id/${VIEW_POSTFIX}`,
  CHANNELS_OK_NOTIFY_NEW: `${CHANNELS_PREFIX}/ok-notify/${NEW_POSTFIX}`,
  CHANNELS_OK_NOTIFY_EDIT: `${CHANNELS_PREFIX}/ok-notify/:id/${EDIT_POSTFIX}`,
  CHANNELS_OK_NOTIFY_VIEW: `${CHANNELS_PREFIX}/ok-notify/:id/${VIEW_POSTFIX}`,

  CHANNELS_MAX_BOT_NEW: `${CHANNELS_PREFIX}/max-bot/${NEW_POSTFIX}`,
  CHANNELS_MAX_BOT_EDIT: `${CHANNELS_PREFIX}/max-bot/:id/${EDIT_POSTFIX}`,
  CHANNELS_MAX_BOT_VIEW: `${CHANNELS_PREFIX}/max-bot/:id/${VIEW_POSTFIX}`,

  CHANNELS_MAX_NEW: `${CHANNELS_PREFIX}/max/${NEW_POSTFIX}`,
  CHANNELS_MAX_EDIT: `${CHANNELS_PREFIX}/max/:id/${EDIT_POSTFIX}`,
  CHANNELS_MAX_VIEW: `${CHANNELS_PREFIX}/max/:id/${VIEW_POSTFIX}`,
  CHANNELS_MAX_TECH_PARTNER_NEW: `${CHANNELS_PREFIX}/max${CHANNELS_TECH_PARTNER_POSTFIX}/${NEW_POSTFIX}`,
  CHANNELS_MAX_TECH_PARTNER_EDIT: `${CHANNELS_PREFIX}/max${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${EDIT_POSTFIX}`,
  CHANNELS_MAX_TECH_PARTNER_VIEW: `${CHANNELS_PREFIX}/max${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${VIEW_POSTFIX}`,

  CHANNELS_TELEGRAM_NEW: `${CHANNELS_PREFIX}/telegram/${NEW_POSTFIX}`,
  CHANNELS_TELEGRAM_EDIT: `${CHANNELS_PREFIX}/telegram/:id/${EDIT_POSTFIX}`,
  CHANNELS_TELEGRAM_VIEW: `${CHANNELS_PREFIX}/telegram/:id/${VIEW_POSTFIX}`,
  CHANNELS_TELEGRAM_TECH_PARTNER_NEW: `${CHANNELS_PREFIX}/telegram${CHANNELS_TECH_PARTNER_POSTFIX}/${NEW_POSTFIX}`,
  CHANNELS_TELEGRAM_TECH_PARTNER_EDIT: `${CHANNELS_PREFIX}/telegram${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${EDIT_POSTFIX}`,
  CHANNELS_TELEGRAM_TECH_PARTNER_VIEW: `${CHANNELS_PREFIX}/telegram${CHANNELS_TECH_PARTNER_POSTFIX}/:id/${VIEW_POSTFIX}`,

  // Cascades
  CASCADES_NEW: `/cascades/${NEW_POSTFIX}`,
  CASCADES_VIEW: `/cascades/:id/${VIEW_POSTFIX}`,
  CASCADES_LIST: '/cascades',

  // Broadcasts
  BROADCASTS_LIST: '/broadcasts',
  BROADCASTS_NEW: `/broadcasts/${NEW_POSTFIX}`,
  BROADCASTS_DETAILS: '/broadcasts/:id/details',
  BROADCASTS_EDIT: '/broadcasts/:id/:action/:step',

  // Subscribers
  SUBSCRIBERS_LIST: '/audience',
  SUBSCRIBERS_NEW: `/audience/${NEW_POSTFIX}`,
  SUBSCRIBERS_GROUP_EDIT: `/audience/add-list/${EDIT_POSTFIX}`,
  SUBSCRIBERS_EDIT: `/audience/:id/${EDIT_POSTFIX}`,

  // Message matchers
  MESSAGE_MATCHERS: `${MESSAGE_MATCHERS_PREFIX}`,
  MESSAGE_MATCHERS_TAB: `${MESSAGE_MATCHERS_PREFIX}/:tab`,
  MESSAGE_MATCHERS_LIST: `${MESSAGE_MATCHERS_PREFIX}/${EMessageMatchersTab.LIST}`,
  MESSAGE_MATCHERS_PRESETS: `${MESSAGE_MATCHERS_PREFIX}/${EMessageMatchersTab.PRESETS}`,
  MESSAGE_MATCHERS_WHATSAPP_NEW: `${MESSAGE_MATCHERS_PREFIX}/whatsapp/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_WHATSAPP_EDIT: `${MESSAGE_MATCHERS_PREFIX}/whatsapp/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_WHATSAPP_VIEW: `${MESSAGE_MATCHERS_PREFIX}/whatsapp/:id/${VIEW_POSTFIX}`,
  MESSAGE_MATCHERS_VIBER_NEW: `${MESSAGE_MATCHERS_PREFIX}/viber/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_VIBER_EDIT: `${MESSAGE_MATCHERS_PREFIX}/viber/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_VIBER_VIEW: `${MESSAGE_MATCHERS_PREFIX}/viber/:id/${VIEW_POSTFIX}`,
  MESSAGE_MATCHERS_SMS_NEW: `${MESSAGE_MATCHERS_PREFIX}/sms/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_SMS_EDIT: `${MESSAGE_MATCHERS_PREFIX}/sms/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_SMS_VIEW: `${MESSAGE_MATCHERS_PREFIX}/sms/:id/${VIEW_POSTFIX}`,
  MESSAGE_MATCHERS_PUSH_NEW: `${MESSAGE_MATCHERS_PREFIX}/push/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_PUSH_EDIT: `${MESSAGE_MATCHERS_PREFIX}/push/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_PUSH_VIEW: `${MESSAGE_MATCHERS_PREFIX}/push/:id/${VIEW_POSTFIX}`,
  MESSAGE_MATCHERS_OK_NOTIFY_NEW: `${MESSAGE_MATCHERS_PREFIX}/ok-notify/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_OK_NOTIFY_EDIT: `${MESSAGE_MATCHERS_PREFIX}/ok-notify/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_OK_NOTIFY_VIEW: `${MESSAGE_MATCHERS_PREFIX}/ok-notify/:id/${VIEW_POSTFIX}`,
  MESSAGE_MATCHERS_VK_NOTIFY_NEW: `${MESSAGE_MATCHERS_PREFIX}/vk-notify/${NEW_POSTFIX}`,
  MESSAGE_MATCHERS_VK_NOTIFY_EDIT: `${MESSAGE_MATCHERS_PREFIX}/vk-notify/:id/${EDIT_POSTFIX}`,
  MESSAGE_MATCHERS_VK_NOTIFY_VIEW: `${MESSAGE_MATCHERS_PREFIX}/vk-notify/:id/${VIEW_POSTFIX}`,

  // Triggers
  TRIGGERS_LIST: TRIGGERS_PREFIX,
  TRIGGERS_NEW: `${TRIGGERS_PREFIX}/${NEW_POSTFIX}`,
  TRIGGERS_EDIT: `${TRIGGERS_PREFIX}/:id/${EDIT_POSTFIX}`,
  TRIGGERS_VIEW: `${TRIGGERS_PREFIX}/:id/${VIEW_POSTFIX}`,

  // News
  NEWS: `/news`,
  NEWS_TAB: `/news/:tab`,
  NEWS_BLOG: `/news/${ECompanyNewsTab.BLOG}`,
  NEWS_CASES: `/news/${ECompanyNewsTab.CASES}`,

  // Company
  COMPANY_PROFILE: `/company/profile`,
  COMPANY_PROFILE_TAB: `/company/profile/:tab/*`,
  COMPANY_PROFILE_PAYMENT: `/company/profile/${EUserCompanyProfileTabs.PAYMENT}/:paymentTab`,
  COMPANY_PROFILE_TARIFFS: `/company/profile/${EUserCompanyProfileTabs.LICENSE}?section=tariffs`,
  COMPANY_CLIENTS: '/company/clients',
  COMPANY_CLIENT_NEW: `/company/clients/${NEW_POSTFIX}`,
  COMPANY_CLIENT_EDIT: `/company/clients/:id/${EDIT_POSTFIX}`,
  COMPANY_CLIENT_CARD: `/company/clients/:id/${VIEW_POSTFIX}`,
  COMPANY_AGENT_CLIENTS: '/company/agents',
  COMPANY_AGENT_CLIENT_NEW: `/company/agents/${NEW_POSTFIX}`,
  COMPANY_AGENT_CLIENT_CARD: '/company/agents/:id',

  // Support
  SUPPORT: `${SUPPORT_PREFIX}`,
  SUPPORT_TABS: `${SUPPORT_PREFIX}/:tab`,
  SUPPORT_CLIENTS: SUPPORT_CLIENTS_PREFIX,
  SUPPORT_VERIFICATIONS: `${SUPPORT_PREFIX}/verifications`,
  SUPPORT_VERIFICATIONS_VIEW: `${SUPPORT_PREFIX}/verifications/:id/${VIEW_POSTFIX}`,
  SUPPORT_VERIFICATIONS_CHECK: `${SUPPORT_PREFIX}/verifications/:id/check`,
  SUPPORT_CLIENT_CARD: `${SUPPORT_CLIENTS_PREFIX}/:id`,
  SUPPORT_CLIENT_CARD_TAB: `${SUPPORT_CLIENTS_PREFIX}/:id/:tab`,
  SUPPORT_CLIENT_CARD_PAYMENT: `${SUPPORT_CLIENTS_PREFIX}/:id/${EUserCompanyProfileTabs.PAYMENT}/:paymentTab`,
  SUPPORT_INVOICE_ASSIGN: `/support/invoice/assign`,
  SUPPORT_INVOICE_CANCEL: `/support/invoice/cancel`,

  // Support message matchers
  SUPPORT_MESSAGE_MATCHERS_LIST: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${MESSAGE_MATCHERS_PREFIX}`,
  SUPPORT_MESSAGE_MATCHER_VIEW: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${MESSAGE_MATCHERS_PREFIX}/:channelType/:id/${VIEW_POSTFIX}`,

  // Support analytics
  SUPPORT_ANALYTICS_MESSAGES: `${SUPPORT_CLIENTS_PREFIX}/:tenantId/analytics/messages`,
  SUPPORT_ANALYTICS_SUMMARY_REPORT: `${SUPPORT_CLIENTS_PREFIX}/:tenantId/analytics/channels`,
  SUPPORT_ANALYTICS_CHANNEL: `${SUPPORT_CLIENTS_PREFIX}/:tenantId/analytics/channels/:type/:id`,

  // Support channels
  SUPPORT_CHANNELS_LIST: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${CHANNELS_PREFIX}`,
  SUPPORT_CHANNEL_VIEW: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${CHANNELS_PREFIX}/:channelType/:id/${VIEW_POSTFIX}`,

  // Support triggers
  SUPPORT_TRIGGERS_LIST: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${TRIGGERS_PREFIX}`,
  SUPPORT_TRIGGERS_VIEW: `${SUPPORT_CLIENTS_PREFIX}/:tenantId${TRIGGERS_PREFIX}/:id/${VIEW_POSTFIX}`,

  // Support agents
  SUPPORT_AGENT_CLIENTS: `/company/agents/:tenantId/agent/clients`,
  SUPPORT_AGENT_CLIENT_CARD: `/company/agents/:tenantId/agent/clients/:id`,
  SUPPORT_AGENT_PAYMENTS: `/company/agents/:tenantId/agent/payments`,
  SUPPORT_AGENT_PAYMENTS_TAB: `/company/agents/:tenantId/agent/payments/:tab`,

  // Integration
  INTEGRATION: '/integration',
  INTEGRATION_TAB: '/integration/:tab/*',
  INTEGRATION_SETTINGS_TAB: '/integration/settings/:settingsTab',
  INTEGRATION_SETTINGS_API_KEY_NEW: '/integration/settings/api-key/new',
  INTEGRATION_SETTINGS_CALLBACK_NEW: '/integration/settings/callback/new',
  INTEGRATION_SETTINGS_CALLBACK_EDIT: '/integration/settings/callback/:id',

  // Analytics
  ANALYTICS_MESSAGES: '/analytics/messages',
  ANALYTICS_SUMMARY_REPORT: '/analytics/channels',
  ANALYTICS_CHANNEL: '/analytics/channels/:type/:id',
  ANALYTICS_MESSAGE_MATCHERS_LIST: '/analytics/message-matchers',
  ANALYTICS_MESSAGE_MATCHER: '/analytics/message-matchers/:id',

  // Corrections
  CORRECTIONS: '/corrections',
  CORRECTIONS_TAB: '/corrections/:tab',
  CORRECTIONS_MIGRATION_TAB: '/corrections/migration/:migrationTab',

  // Notifications
  NOTIFICATIONS: '/event-log',
  NOTIFICATIONS_TAB: '/event-log/:tab',

  // Tariffs
  TARIFFS: '/tariffs',
  TARIFF_CARD: '/tariffs/:id',
  TARIFF_CARD_DETAIL_NEW: '/tariffs/:tariffId/details/new',
  TARIFF_CARD_DETAIL_EDIT: '/tariffs/:tariffId/details/:id/:version',
  TARIFF_CARD_PRICING_DETAIL_NEW:
    '/tariffs/:tariffId/details/:detailId/:detailVersion/pricing-details/new',
  TARIFF_CARD_PRICING_DETAIL_EDIT:
    '/tariffs/:tariffId/details/:detailId/:detailVersion/pricing-details/:id/:version',

  // Sundry
  PROFILE: '/profile',
  AUDIENCE: '/audience',
  CONTENT_MANAGER: '/content-manager',
  HELP: '/help',
  SIGN_OUT: '/signout',
  FILES: '/files',

  // Agents
  AGENT_PAYMENTS: '/agent/payments',
  AGENT_PAYMENTS_TAB: '/agent/payments/:tab',
  AGENT_CLIENTS: '/agent/clients',
  AGENT_CLIENT_CARD: '/agent/clients/:id',
  AGENT_PROFILE: '/agent/profile',

  DIALOGS: '/dialogs',
  DIALOGS_NEW: '/dialogs/new',
  DIALOGS_MESSAGES: '/dialogs/:id',
};

export default PATHS;

export const useViewMatch = () => {
  const {pathname} = useLocation();

  return pathname.endsWith(VIEW_POSTFIX);
};

export const useNewMatch = () => {
  const {pathname} = useLocation();

  return pathname.endsWith(NEW_POSTFIX);
};

export const getMatchedPaths = (pathname: string) =>
  Object.values(PATHS)
    .filter((path) => matchPath(`${path}/*`, pathname))
    .sort((a, b) => b.length - a.length);
